import { useEffect } from 'react'
import { Box } from '@mui/material'
import Head from 'next/head'
import { useSession } from 'next-auth/react'

import InfoBar from '#/app/layout/ui/info-bar'
import { useAppDispatch } from '#/app/store/store'
import { getUserBalance } from '#/entities/balance'
import { getAllInfo } from '#/entities/user-account'
import { ChangePasswordPlate } from '#/features/change-password-corp'
import { ErrorReportPlate } from '#/features/error-report'
import { change } from '#/features/pending'
import { getDeviceType } from '#/shared/lib/helpers'
import { MainMenuMobile } from '#/widgets/main-menu'
import { SideMenu } from '#/widgets/side-menu'

import { LayoutProps } from '../types'
import { LayoutWithoutSideMenu } from './layout-without-sidemenu'

export const SharedLayout = ({ children, titlePage, device = getDeviceType() }: LayoutProps) => {
	const dispatch = useAppDispatch()
	const { data: session, status } = useSession()
	const desktop = device === 'desktop'
	const isAuthenticated = status === 'authenticated' && Boolean(session?.access)

	useEffect(() => {
		if (!session?.access) {
			return
		}

		void (async () => {
			await dispatch(getUserBalance(session.access))
			await dispatch(getAllInfo(session.access))
			dispatch(change(false))
		})()
	}, [dispatch, session?.access])

	if (!isAuthenticated) {
		return (
			<LayoutWithoutSideMenu titlePage={titlePage} device={device}>
				{children}
			</LayoutWithoutSideMenu>
		)
	}

	return (
		<>
			<Head>
				{titlePage && <title>{titlePage}</title>}
				<meta name='AIR' />
				<meta name='viewport' content='width=device-width, initial-scale=1' />
				<link rel='icon' href='/logo.svg' />
				<link rel='apple-touch-icon' href='/logo180.png' />
				<link rel='manifest' href='/manifest.json' />
			</Head>
			<Box
				id='layout'
				sx={{
					width: '100%',
					height: desktop ? '100%' : '100dvh',
					padding: desktop ? '0px' : '10px',
					overflow: desktop ? undefined : 'hidden',
					backgroundColor: '#151518',
				}}
			>
				<Box
					sx={{
						padding: desktop ? '0px' : '1px',
						height: desktop ? undefined : '100%',
						minHeight: 0,
					}}
				>
					{desktop ? (
						<Box display='flex' justifyContent='center'>
							<SideMenu />
							<Box
								width='100%'
								sx={{
									padding: '5px 0px 0px 70px',
									marginLeft: '60px',
									overflowX: 'hidden',
									minHeight: '100dvh',
									backgroundColor: '#151518',
									height: '100dvh',
									display: 'flex',
									flexDirection: 'column',
									overflow: 'hidden',
								}}
							>
								<InfoBar device={device} token={''} />
								<Box
									sx={{
										flex: 1,
										minHeight: 0,
										overflow: 'hidden',
										display: 'flex',
										flexDirection: 'column',
									}}
									width='100%'
								>
									{children}
								</Box>
							</Box>
						</Box>
					) : (
						<Box
							sx={{
								display: 'flex',
								flexDirection: 'column',
								height: '100%',
								minHeight: 0,
								overflow: 'hidden',
								backgroundColor: '#151518',
							}}
						>
							<MainMenuMobile />
							<Box
								sx={{
									flex: 1,
									minHeight: 0,
									overflow: 'hidden',
									display: 'flex',
									flexDirection: 'column',
								}}
							>
								{children}
							</Box>
						</Box>
					)}
				</Box>
				<ChangePasswordPlate />
				<ErrorReportPlate />
			</Box>
		</>
	)
}
